// App.js
import React from 'react';
import './App.css';
import AppRoutes from './AppRoutes/AppRoutes';
import Header from './Pages/Header';
import Footer from './Pages/Footer';
import { LoginProvider } from './Pages/LoginContext'; // adjust path as needed
import { Provider } from "react-redux";
import store from "./Redux/store";

const AppContent = () => {
  return (
    <>
      <Header />
      <div className='min-height-80'>
        <AppRoutes />
      </div>
      <Footer />
    </>
  );
};

function App() {
  // No need for local config loading now that it's handled in index.js
  return (
    <div className="App">
      <Provider store={store}>
        <LoginProvider>
          <AppContent />
        </LoginProvider>
      </Provider>
    </div>
  );
}

export default App;
